import { render, staticRenderFns } from "./DeployLocation.vue?vue&type=template&id=2157d762&scoped=true&"
import script from "./DeployLocation.vue?vue&type=script&lang=js&"
export * from "./DeployLocation.vue?vue&type=script&lang=js&"
import style0 from "./DeployLocation.vue?vue&type=style&index=0&id=2157d762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157d762",
  null
  
)

/* custom blocks */
import block0 from "./DeployLocation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VContainer,VSpacer,VTab,VTabItem})
